import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';

const actions = {
  async getRushes({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.rushes,
        isToken: true,
      });
      commit('GET_RUSHES_SUCCESS', data);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async createRushes({ dispatch }, payload) {
    try {
      await apiCall({
        type: 'POST',
        url: `${URLS.rushes}`,
        body: payload,
        isToken: true,
      });
      notificationWithIcon('success', 'Rush added');
      dispatch('getRushes');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async changeRush({ dispatch }, payload) {
    const {
      id,
      percent,
      enhance,
      photoArt,
      digitize,
      isDefault,
      companyId,
    } = payload;

    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.rushes}/${id}`,
        body: {
          percent,
          enhance,
          photoArt,
          digitize,
          isDefault,
          companyId: companyId ?? null,
        },
        isToken: true,
      });
      notificationWithIcon('success', 'Rush updated');
      dispatch('getRushes');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteRush({ dispatch }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.rushes}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Rush deleted');
      dispatch('getRushes');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
